"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleAddButton = void 0;

var toggleAddButton = function toggleAddButton(currentElements, gridComponent) {
  var maxDataRows = gridComponent.component.maxDataRows;

  if (maxDataRows) {
    var buttonWrapperElement = gridComponent.element.querySelector('.add-btn-wrapper');

    if (buttonWrapperElement) {
      var messageElement = buttonWrapperElement.querySelector('.add-btn-message');
      var buttonElement = buttonWrapperElement.querySelector('button');

      if (currentElements >= maxDataRows) {
        buttonElement.setAttribute('disabled', true);
        messageElement.textContent = gridComponent.t('maxRows');
        gridComponent.isCanAddRow = false;
      } else {
        buttonElement.removeAttribute('disabled');
        messageElement.textContent = '';
        gridComponent.isCanAddRow = true;
      }
    }
  }
};

exports.toggleAddButton = toggleAddButton;